var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header__logout"},[_c('Icon',{attrs:{"name":'logout',"color":'white',"size":[18, 18],"className":'header__icon header__icon--actions',"title":'Выход'},on:{"click":_vm.logout}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }